import { throttle } from 'lodash'
import { useEffect, useRef } from 'react'
import { NativeEventEmitter, NativeModules } from 'react-native'

import { ONGOING_VIDEO_CALL_EVENT } from '../../hooks/use-ongoing-video-call-event'

const MOUSEMOVE_EVENT = 'mousemove'
const MOUSEDOWN_EVENT = 'mousedown'
const RESIZE_EVENT = 'resize'
const KEYDOWN_EVENT = 'keydown'
const TOUCHSTART_EVENT = 'touchstart'
const WHEEL_EVENT = 'wheel'

const events = [MOUSEMOVE_EVENT, MOUSEDOWN_EVENT, RESIZE_EVENT, KEYDOWN_EVENT, TOUCHSTART_EVENT, WHEEL_EVENT]
const eventEmitter = new NativeEventEmitter(NativeModules.RNEventEmitter)

export function useUserActivity(fn: VoidFunction, throttleMs: number) {
  const callback = useRef(fn)

  useEffect(() => {
    const onEvent = throttle(() => callback.current(), throttleMs)

    for (let i = 0; i < events.length; i++) {
      window.addEventListener(events[i], onEvent)
    }

    const ongoingVideoCallListenerSubscription = eventEmitter.addListener(ONGOING_VIDEO_CALL_EVENT, onEvent)

    document.addEventListener('visibilitychange', onEvent)

    return () => {
      for (let i = 0; i < events.length; i++) {
        window.removeEventListener(events[i], onEvent)
      }

      document.removeEventListener('visibilitychange', onEvent)
      ongoingVideoCallListenerSubscription.remove()
    }
  }, [throttleMs])

  useEffect(() => {
    callback.current = fn
  }, [fn])
}
